export default __webpack_public_path__ + "static/media/abused.1d676a89.svg";